import React from 'react';
import DashboardLayout from '../../components/layouts/dashboardLayout';
import AddProductForm from '../../components/forms/addProductForm';

let inputs = {
   title: "",
   description: "",
   features: "",
   instructions: "",
   disclaimer: "",
   image: "",
   images: [],

   colors: [],
   colorLinking: false,

   multiPrices: false,
   optionsTitle: "Product Size",
   multiPriceList: [
      // {
      //    title: "SM",
      //    description: "Product length and other details.",
      //    sellPrice: 100,
      //    oldPrice: 200,
      //    cost: 230,
      //    barCode: "",
      //    stockInHand: "", 
      //    color: ""
      // }
   ],
   sellPrice: 0,
   oldPrice: 0,
   cost: 0,
   barCode: "",
   youtubeLinks: [],
   category: "",
   subcategory: "",
   sellEvenOutOfStock: false,
   brand: "",
   stockInHand: 1,
   remainingQuantityView: true,
   allowOrderEvenQuantityEmpty: true,
   textCharge: false,
   usedCondition: false,

   physicalState: false,
   weight: 0,
   height: 0,
   width: 0,
   length: 0,

   customInput: false,
   customInputTitle: "Enter your Name",

   type: "product",
   featured: false,
   sales: false,
   sell: true,
   newArrival: false,
   upcoming: false,
   takeUpcomingOrder: false,

   metaTitle: "metaTitle",
   metaDesc: "metaDesc",
}
let AddProduct = () => {
   return (
      <>
         <DashboardLayout>
            <AddProductForm inputs={inputs} />
         </DashboardLayout >
      </>
   )
}

export default AddProduct